
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import AppRecoveryScreen from './components/common/AppRecoveryScreen';
import { clearPreviewWorker, isPreviewRuntime, markAppHealthy, recoverAppLoad, reloadApp } from './lib/appRecovery';
import './index.css';
import './styles/dark-compat.css';

async function startApp() {
  const rootElement = document.getElementById("root");
  if (!rootElement) return;
  let healthyTimer: ReturnType<typeof setTimeout> | undefined;
  const onError = (error: Error) => {
    clearTimeout(healthyTimer);
    recoverAppLoad(error);
  };
  try {
    await clearPreviewWorker();
    const { default: App } = await import('./App.tsx');
    createRoot(rootElement).render(
      <ErrorBoundary fallback={<AppRecoveryScreen />} onError={onError}>
        <App />
      </ErrorBoundary>
    );
    // A successful import is not enough: let provider rendering settle first.
    healthyTimer = setTimeout(markAppHealthy, 10000);
    if ("serviceWorker" in navigator && import.meta.env.PROD && !isPreviewRuntime()) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .catch((error) => {
            console.error("Service worker registration failed:", error);
          });
      });
    }
  } catch (error) {
    if (recoverAppLoad(error)) return;
    // Also survives a failed import before React can mount an error boundary.
    const message = document.createElement('p');
    message.textContent = 'Masira couldn’t load. Please try again. Your saved learning is safe.';
    const retry = document.createElement('button');
    retry.textContent = 'Try again';
    retry.addEventListener('click', reloadApp);
    rootElement.replaceChildren(message, retry);
  }
}

void startApp();
